// Auto-generated skeleton for Cis

import { CisType } from "./CisType";
import { Team } from "./Team";
import { User } from "./User";

export const Cis: Api.Cis = {
  id: 0,
  hp_id: null,
  cis_type_id: 0,
  cis_type: CisType,
  text: '',
  info_1: null,
  info_2: null,
  date: '',
  time: 0,
  is_internal: false,
  processing_minutes: 0,
  team_id_created: 0,
  team_created: Team,
  user_id_created: 0,
  user_created: User,
  documents_count: 0,
  documents: [],
  buildings: [],
  units: [],
  records: [],
  persons: [],
  craftsman_tasks: [],
  created: null,
  updated: null,
};

